import { initPaperDeckPlayer } from '../content/paper-deck-player.js';

// The stock Deckwerk bundle registers its boot listener before this module.
// Deferred modules run while readyState is "interactive", before the stock
// player's DOMContentLoaded boot. Wait for that boot in both pre-load states.
if (document.readyState !== 'complete') {
  document.addEventListener('DOMContentLoaded', initPaperDeckPlayer, { once: true });
} else {
  initPaperDeckPlayer();
}
